import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/system'

export default makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      height: '100%',
      fontFamily: 'LatoNormal',
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column"
      }
    },
    containerLeft: {
      width: "28%",
      height: "100%",
      borderRight: '2px solid var(--border-color)',
      position: 'sticky',
      top: 0,
      overflow: 'scroll',
      [theme.breakpoints.down("sm")]: {
        position: "relative",
        width: "100%",
        height: "auto",
        overflow: 'visible'
      }
    },
    relativeContainer: {
      [theme.breakpoints.down("sm")]: {
        marginBottom: '6rem'
      }
    },
    headerSticky: {
      position: 'sticky',
      top: 0,
      zIndex: 10,
      backgroundColor: 'var(--white-color)'
    },
    requestMoreButton: {
      height: '54px',
      padding: '0 .5rem',
      color: 'var(--bosscat-blue-600)',
      backgroundColor: 'white',
      borderRadius: 8,
      textTransform: 'inherit',
      margin: '5px',
      transition: '300ms all',
      '&:hover': {
        color: 'white',
        transition: '300ms all',
      },
      '@global': {
        '.MuiTypography-root': {
          fontWeight: 900,
        }
      },
      endIcon: {
        width: '5px',
        height: '5px'
      },
      [theme.breakpoints.down('md')]: {
        width: 'fit-content',
        height: '48px',
        borderRadius: 32,
        color: '#0B060F'
      },
      /*  [theme.breakpoints.down('sm')]: {
         marginBottom: '8rem'
       } */
    },
    expandButton: {
      color: '#6D6A6F',
      fontWeight: 700
    },
    containerRight: {
      width: "80%",
      height: "100%",
      overflowY: 'scroll',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      padding: '.5rem',
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        overflowY: 'inherit',
        padding: '0',
        gap: '.5rem',
        marginBottom: '6rem'
      },
    },
    modal: {
      '@global': {
        '.MuiPaper-root': {
          width: '100%',
          height: '100%'
        },
        '.MuiButtonBase-root': {
          padding: '0 !important',
          display: 'flex',
          position: 'inherit',
          alignItems: 'flex-start'
        },
        '.MuiIconButton-root': {
          padding: '0 !important',
        }
      }
    },
    cartModal: {
      '@global': {
        '>.MuiDialog-container >.MuiPaper-root': {
          minWidth: 786,
          minHeight: '100vh',
          position: 'absolute',
          right: 0,
          margin: 0,
          top: 0,
          width: "auto",
          [theme.breakpoints.down('sm')]: {
            minWidth: '100%',
          }
        },
        '.MuiDialogTitle-root': {
          paddingBottom: 0,
          [theme.breakpoints.down('sm')]: {
            borderBottom: '2px solid #EFF0F1',
            paddingBottom: '1rem'
          },
          '@global': {
            '.MuiGrid-root': {
              justifyContent: 'space-between'
            }
          }
        },
        '.MuiDialogContent-root': {
          padding: '1rem !important',
          paddingTop: '0 !important',

          [theme.breakpoints.down('sm')]: {
            padding: '0.4rem !important',
            display: 'flex !important',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }
        },
        '.MuiDialog-container': {
          maxWidth: '100%'
        }
      }
    },
    list: {
      // margin: '20px 0px'
    },
    subHeader: {
      // backgroundColor: 'var(--progress-color-back)',
      borderRadius: '8px',
      padding: 0,
      position: 'static'
    },
    categoryContainer: {
      padding: '.5rem 0'
    },
    listItem: {
      justifyContent: 'space-between'
    },
    item: {
      color: 'var(--head-text-color) !important',
      fontFamily: 'LatoNormal !important',
      fontWeight: '500 !important',
      fontSize: '16px !important',
      lineHeight: '24px !important'
    },
    itemType: {
      color: 'var(--head-text-color) !important',
      fontFamily: 'LatoBold !important',
      fontWeight: '500 !important',
      fontSize: '16px !important',
      lineHeight: '24px !important',
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px  !important',
        lineHeight: '18px !important'
      }
    },
    goldBanner: {
      marginTop: '1rem !important'
    },
    itemEnd: {
      color: 'var(--head-text-color) !important',
      fontFamily: 'LatoNormal !important',
      fontWeight: '500 !important',
      fontSize: '16px !important',
      lineHeight: '24px !important',
      alignSelf: 'flex-end',
      maxWidth: '100px !important'
    },
    cartHeader: {
      [theme.breakpoints.down('sm')]: {
        // marginLeft: '1rem',
        display: 'flex !important',
        flexDirection: 'column',
        alignItems: 'center !important',
        width: '100% !important'
      }
    },
    cartTitleContainer: {
      display: 'flex !important',
      alignItems: 'center',
      gap: '.5rem !important',
      [theme.breakpoints.down('sm')]: {
        width: '100% !important',
        flexDirection: 'column',
        gap: 0
      }
    },
    row: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    cartTitle: {
      fontFamily: 'NextArtHeavy !important',
      fontSize: '28px !important',
      [theme.breakpoints.down('sm')]: {
        fontSize: '24px !important',
      }
    },
    cartIcon: {
      [theme.breakpoints.down('sm')]: {
        marginRight: '.4rem !important'
      }
    },
    arrowBack: {
      position: 'absolute',
      left: '-1rem'
    },
    estimateValid: {
      width: '100%',
      display: 'block',
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      }
    },
    categoryTitle: {
      fontFamily: 'NextArtHeavy !important',
      color: 'var(--head-text-color) !important',
      marginRight: '10px !important'
    },
    title: {
      fontFamily: 'NextArtHeavy !important',
      fontSize: '20px !important',
      marginBottom: '1rem !important'
    },
    categoryHeader: {
      display: 'flex',
      gap: '.2rem'
    },
    price: {
      fontFamily: 'LatoBold !important',
      fontWeight: '700 !important',
      fontSize: '16px !important',
      lineHeight: '58px !important',
      color: 'var(--head-text-color) !important'
    },
    icon: {
      /*  color: 'var(--head-text-color)',
       // margin: '18px 8px',
       width: '22px',
       height: '22px' */
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      /* '@global': {
        'path': {
          fill: 'var(--bosscat-blue-600)'
        }
      } */
    },
    expand: {
      color: 'var(--white-color) !important'
    },
    expandBox: {
      width: '26px !important',
      height: '26px !important',
      borderRadius: '4px !important',
      backgroundColor: 'var(--bosscat-blue-600) !important',
      justifyContent: 'center',
      alignItems: 'center'
    },
    chart: {
      display: 'flex !important',
      flexDirection: 'row',
      maxHeight: '300px !important',
      margin: '10px 20px 20px 80px',
      [theme.breakpoints.down('lg')]: {
        margin: '10px 20px 20px 20px'
      },
      [theme.breakpoints.down('sm')]: {
        margin: '0px 0px 0px 5px',
        maxHeight: '160px',
        maxWidth: '160px'
      }
    },
    titleChart: {
      fontFamily: 'LatoNormal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '30px',
      color: 'var(--head-text-color)',
      marginLeft: '5px',
      [theme.breakpoints.down('sm')]: {
        marginLeft: '10px',
        width: '100%',
        marginBottom: '1rem'
      }
    },
    detail: {
      fontFamily: 'Lato',
      fontWeight: 400,
      lineHeight: '24px',
      fontSize: '16px',
      margin: '0px',
      color: 'var(--bosscat-blue-600)',
      backgroundColor: 'var(--row-background)'
    },
    button: {
      height: '33px',
      width: '80px',
      minWidth: '80px',
      margin: '0px 2px',
      textTransform: 'none',
      border: '1px solid var(--bosscat-blue-600)',
      borderRadius: '8px',
      backgroundColor: 'var(--row-background)',
      '&:hover': {
        backgroundColor: 'var(--row-background)'
      }
    },
    buttonContent: {
      justifyContent: 'flex-end'
    },
    percentContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    },
    percent: {
      display: 'flex',
      margin: '2px 12px',
      padding: '8px',
      height: '40px',
      width: '48px',
      borderRadius: 8,
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        margin: '2px 5px',
        height: '32px',
        width: '40px'
      }
    },
    itemPercent: {
      fontFamily: 'LatoNormal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '24px',
      color: 'var(--white-color)',
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        lineHeight: '18px'
      }

    },
    number: {
      color: 'var(--head-text-color)',
      fontFamily: 'LatoNormal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      marginLeft: '4px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        lineHeight: '18px'
      }
    },
    marks: {
      position: 'fixed',
      bottom: '-48px',
      right: '-8px',
      transform: 'rotate(125deg)',
      color: 'var(--text-color)',
      width: '128px',
      display: 'flex'
    },
    spinner: {
      '& .MuiCircularProgress-circle': {
        color: 'var(--white-color)'
      }
    },
    center: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: 10,
      backgroundColor: 'rgba(24, 24, 24, .4)'
    },
    addressBox: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      borderRadius: '10px',
      borderColor: 'var(--head-text-color)',
      border: '1px solid var(--head-text-color)',
      backgroundColor: 'var(--background-color-secondary)',
      margin: '0px 12px'
    },
    total: {
      fontSize: '18px',
      padding: '8px'
    },
    text: {
      fontFamily: 'BetterSansRegular',
      fontWeight: 700,
      borderRadius: '8px',
      padding: '6px 16px 4px',
      color: 'var(--bosscat-blue-600)',
      backgroundColor: 'rgba(250, 251, 255, 1)',
      textAlign: 'center'
    },
    alert: {
      width: '100%',
      height: 'auto',
      backgroundColor: 'var(--white-color)',
      border: '2px solid var(--border-color)',
      borderRadius: '16px 16px 0px 0px',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      position: 'sticky',
      bottom: 0,
      zIndex: 12
    },
    back: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(26, 42, 85, 0.6)',
      position: 'sticky',
      bottom: 0,
      zIndex: 11
    },
    info: {
      width: '248px',
      // height: '168px',
      backgroundColor: 'var(--white-color)',
      border: '2px solid var(--border-color)',
      borderRadius: '8px',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: 0,
      left: 20,
      zIndex: 13
    },
    evaluateDisclamerBox: {
      padding: '12px 16px',
      margin: '0.25rem',
      borderRadius: '6px',
      color: 'var(--punchlist-red)',
      border: '1px solid var(--punchlist-red)'
    },
    evaluateDisclamerIcon: {
      float: 'left',
      height: '20px',
      marginRight: '6px'
    },
    evaluateDisclamerText: {
      fontSize: '13px',
      fontStyle: 'italic',
      fontFamily: 'LatoNormal',
      fontWeight: 400,
      lineHeight: '21px',
      color: 'var(--punchlist-red)'
    },
    evaluateContainer: {

    },
    buttonAdd: {
      minWidth: '86px',
      height: '48px',
      textTransform: 'none',
      color: '#01AA59',
      fontWeight: 700,
      backgroundColor: '#E6F7EE',
      borderRadius: 8,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '40px'
      },
      margin: '5px',
      '&:hover': {
        backgroundColor: '#E6F7EE',
      }
    },
    itemDetailModal: {
      '@global': {
        '.MuiPaper-root': {
          width: '100%',
          margin: 0
        },
        '.MuiDialog-container': {
          alignItems: 'flex-end'
        }
      }
    },
    smallFont: {},
    successToast: {},
    midFont: {},
    errorToast: {},
    noBorder: {},
  })
)
